export default __webpack_public_path__ + "static/illustration-bus-681e607f331f674da5ef2bc0a86967ac.svg";